import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl, mobile_xs } from '../../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter, HideScrollbar, LineClamp } from '../../../../global/commonStyle';

interface Props {
  isShowHover?: boolean;
  isActive?: boolean;
  isHover?: boolean;
  color?: string;
  isOverdue?: boolean;
  isApplyBottomSpacing?: boolean;
  isComment?: boolean;
  completePercentage?: number;
  isTaskDetailPreview?: boolean;
  isTimeOver?: boolean;
  progress?: number;
  isOverflowHidden?: boolean;
  isDisabled?: boolean;
  hasNextComment?: boolean;
  isMobile?: boolean;
  isKeyboardVisible?: boolean;
  isViewerPrivileged?: boolean;
  fontSize?: number;
  isSelected?: boolean;
}
const Group = styled.div<Props>`
  width: 100%;
  display: flex;
  height: 100%;
  ${mobile_xl(css<Props>`
    flex-direction: column;
    .web-header {
      display: none;
    }
  `)}
`;

const LeftBar = styled.div<Props>`
  width: calc(100% - 350px);
  height: 100%;
  display: flex;
  flex-direction: column;
  border-right: 0.5px solid var(--border-primary);
  ${(props) =>
    props.isTaskDetailPreview &&
    css`
      height: calc(100dvh - 72px);
    `}
  ${mobile_xl(css`
    width: unset;
    height: unset;
    z-index: var(--z-index-header);
    padding-inline: var(--space-20);
    border-right: 0;
    border-bottom: 0.5px solid var(--border-primary);
  `)}
`;

const Header = styled.div<Props>`
  ${FlexBetween}
  padding: var(--space-10) var(--space-24);
  z-index: var(--z-index-999);
  border-bottom: 0.5px solid var(--border-primary);
  ${(props) =>
    props.isTaskDetailPreview &&
    css`
      background-color: var(--background-secondary);
    `}
`;

const HeaderBlock = styled.div<Props>`
  display: flex;
  flex-direction: column;
  min-height: 200px;
  height: 100%;
  ${HideScrollbar}
  ${(props) =>
    props.isOverflowHidden &&
    css`
      overflow: hidden;
    `}
  ${mobile_xl(css`
    height: unset;
  `)}
`;

const Text = styled.span<Props>`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0) var(--space-0) var(--space-0) var(--space-5);
  span {
    margin-left: var(--space-0);
  }
  ${(props) =>
    props.isComment &&
    css`
      margin-left: var(--space-0);
    `}
`;

const HeaderTitle = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
`;

const HeaderContent = styled.div<Props>`
  display: flex;
  flex-direction: column;
  gap: var(--space-0);
  padding-top: var(--space-24);
  ${mobile_xl(css<Props>`
    padding-top: var(--space-3);
    ${(props) =>
      props.isTaskDetailPreview &&
      css`
        padding: var(--space-0);
      `}
  `)}
`;

const Activity = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  padding-top: var(--space-20);
  ${mobile_xl(css`
    padding-top: var(--space-0);
  `)}
`;

const ActivityTitle = styled.h2`
  ${Typography.body_lg_semibold}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const ItemBlock = styled.div`
  display: flex;
  flex-direction: column-reverse;
  padding-left: var(--space-24);
  margin-left: var(--space-24);
`;

const ItemChange = styled.div<Props>`
  display: flex;
  gap: var(--space-12);
  margin-left: -48px;
  padding: var(--space-6) var(--space-12);
  position: relative;
  span {
    word-break: break-word;
  }
  ${mobile_xl(css`
    padding-block: var(--space-8);
  `)}

  ${(props) =>
    props.isHover &&
    css`
      margin-bottom: var(--space-12);
      flex-direction: column;
      gap: var(--space-6);
      padding: var(--space-12);
      background-color: var(--background-primary);
      border-radius: var(--border-radius-12);
      border: 0.5px solid var(--border-primary);
      &:hover {
        .right-section {
          display: block;
        }
      }
      &:first-child {
        margin-bottom: var(--space-12);
      }
      ${mobile_xl(css<Props>`
        margin-bottom: ${props.hasNextComment ? 'var(--space-16)' : 'var(--space-12)'};
        padding-block: var(--space-12);
      `)}
    `}
  :first-child {
    border-left: none;
  }
  ${(props) =>
    props.isApplyBottomSpacing &&
    css`
      margin-top: var(--space-12);
    `}
  ${(props) =>
    props.isActive &&
    css`
      background-color: var(--background-primary);
      border-radius: var(--border-radius-12);
      .right-section {
        display: block;
      }
    `}
  .thread-div {
    cursor: pointer;
    padding: var(--space-8);
    border-radius: var(--border-radius-8);
    border: 0.5px solid var(--border-primary);
    background: var(--background-tertiary);
    width: 100%;
    max-width: fit-content;
    max-width: -webkit-fill-available;
    margin-top: var(--space-6);
    ${mobile_xl(css`
      width: unset;
      max-width: unset;
    `)}
  }
  .content {
    display: flex;
    gap: var(--space-10);
  }
  .line {
    min-width: 2px;
    background-color: var(--text-placeholder);
    height: auto;
    border-radius: var(--border-radius-4);
  }
  .right-div {
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
    ${mobile_xl(css`
      width: 100%;
    `)}
  }
  .right-div-overflow {
    overflow: auto;
  }
  .header {
    display: flex;
    gap: var(--space-12);
    justify-content: space-between;
  }
  .left-header {
    display: flex;
    gap: var(--space-4);
    align-items: center;
    ${mobile_xl(css`
      flex-wrap: wrap;
    `)}
  }
  .name {
    color: var(--text-primary);
    ${Typography.body_md}
  }
  .time {
    color: var(--text-secondary);
    ${Typography.body_md}
  }

  .file-div {
    ${AlignCenter}
    gap: var(--space-5);
    flex-wrap: wrap;
  }
  .image-div {
    max-width: 240px;
    ${AlignCenter}
    gap: var(--space-4);
    svg {
      width: 32px;
      height: 32px;
    }
  }
`;

const RightSection = styled.div`
  display: none;
  position: absolute;
  right: 12px;
  ${mobile_xl(css`
    display: block;
  `)}
  &.active {
    display: block;
  }

  .dropdown-content {
    position: relative;
    z-index: var(--z-index-999);
    top: 10px;
    ${mobile_xs(css`
      left: 64%;
      transform: translate(-50%, 0);
    `)}
  }
  .dropdown-content-not-users {
    position: relative;
    z-index: var(--z-index-999);
    top: 10px;
    ${mobile_xs(css`
      left: 52%;
      transform: translate(-50%, 0);
    `)}
  }
`;

const ReactionDiv = styled.div<Props>`
  cursor: pointer;
  position: relative;
`;

const Portion = styled.div`
  display: flex;
  gap: var(--space-6);
  align-items: flex-start;
  .active {
    border-radius: var(--border-radius-8);
    background-color: var(--neutral-secondary);
    svg path {
      fill: var(--text-primary);
    }
  }
`;

const ReactionContainer = styled.div`
  max-width: fit-content;
`;

const ReactionShow = styled.div<Props>`
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-12);
  padding: var(--space-1) var(--space-7);
  ${AlignCenter}
  gap: var(--space-6);
  width: fit-content;
  margin-top: var(--space-8);
  &:hover {
    background-color: var(--neutral-secondary);
    cursor: pointer;
  }
  .reaction-icon {
    font-size: 13px;
    line-height: 16px;
  }
  p {
    ${Typography.body_md}
    color: var(--text-primary);
    margin: var(--space-0);
  }
  ${(props) =>
    props.isDisabled &&
    `
      pointer-events: none;
    `}
`;

const SubTitle = styled.h1`
  ${Typography.body_md}
  color: var(--text-primary);
  margin: var(--space-0);
  span {
    color: var(--text-secondary);
  }
`;
const ActivityContentView = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  p {
    margin: var(--space-0);
    word-break: break-word;
  }
  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

const ActivitySubContent = styled.div<Props>`
  display: flex;
  gap: var(--space-5);
  ${mobile_xl(css`
    padding-top: var(--space-0);
    row-gap: var(--space-0);
  `)}
  ${(props) =>
    props.isComment &&
    css`
      gap: var(--space-6);
      align-items: center;
      ${mobile_xl(css`
        gap: var(--space-4);
        flex-wrap: wrap;
      `)}
    `}
`;

const ActivitySubContentLeft = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
  ${mobile_xl(css`
    flex-wrap: wrap;
  `)}
`;

const CompanyName = styled.p`
  margin: var(--space-0);
  ${Typography.body_md}
  color: var(--text-primary);
`;

const CompanySection = styled.div<Props>`
  padding-inline: var(--space-4);
  background-color: var(--neutral-secondary);
  border-radius: var(--border-radius-4);
  ${(props) =>
    props.isViewerPrivileged &&
    css`
      cursor: pointer;
      &:hover {
        ${CompanyName} {
          color: var(--text-secondary);
        }
      }
    `}
`;

const SubText = styled.div<{ figmaRefreshLoading?: boolean }>`
  .file-box {
    cursor: pointer;
    max-width: 240px;
    display: inline-flex;
    padding: var(--space-10) var(--space-8);
    background-color: var(--background-primary);
    border: 0.5px solid var(--border-primary);
    border-radius: var(--border-radius-8);
    box-shadow: var(--shadow-card);
    align-items: center;
    gap: var(--space-8);
    margin-top: var(--space-12);
  }
  .image-div {
    width: 32px;
    height: 32px;
  }
  .textarea {
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
    h4 {
      max-width: 184px;
      ${Typography.body_md_medium}
      margin: var(--space-0);
      color: var(--text-primary);
      overflow: hidden;
      text-overflow: ellipsis;
    }
    p {
      ${Typography.body_xs}
      color: var(--text-secondary);
      margin: var(--space-0);
    }
  }
  .svg {
    width: 32px;
    height: 32px;
  }

  .refresh-icon {
    ${(props: { figmaRefreshLoading?: boolean }) =>
      props.figmaRefreshLoading &&
      css`
        pointer-events: none;
      `}
  }

  .e-rte-video .e-video-inline {
    width: 355px !important;
  }

  .e-rte-table td,
  .e-rte-table th {
    border: 0.5px solid var(--border-primary);
  }
`;

const FileSection = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-8);
  cursor: pointer;
  margin-top: var(--space-4);
`;

const LeftBarView = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
`;

const RightBar = styled.div<Props>`
  width: 350px;
  display: flex;
  flex-direction: column;
  position: relative;
  ${HideScrollbar}
  ${(props) =>
    props.isTaskDetailPreview &&
    css`
      height: calc(100dvh - 158px);
    `}
  ${mobile_xl(css`
    height: 100%;
    width: 100%;
    overflow: unset;
    gap: var(--space-24);
    border-bottom: 0.5px solid var(--border-primary);
    padding-bottom: var(--space-20);
  `)}
`;

const Listening = styled.div<{ hideBorderBottom?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  border-bottom: ${({ hideBorderBottom }) => (hideBorderBottom ? 'none' : `0.5px solid var(--border-primary)`)};
  padding: var(--space-24);
  ${mobile_xl(css`
    padding: var(--space-0) var(--space-0) var(--space-20);
  `)}
`;

const RightItemBlocks = styled.div`
  ${AlignCenter}
  gap: var(--space-16);
  pointer-events: none;
  width: fit-content;
  &:hover {
    .left {
      color: var(--text-secondary);
    }

    .right {
      background: var(--background-primary);
      border: 0.5px solid var(--border-primary);
      border-radius: var(--border-radius-8);
    }
  }
  .dropdown {
    position: relative;
    top: 0;
  }
  ${mobile_xl(css`
    padding: var(--space-0);
  `)}
`;
const RightItemBlock = styled.div<Props>`
  ${AlignCenter}
  gap: var(--space-16);
  pointer-events: none;
  &:hover {
    .left {
      color: var(--text-secondary);
    }
    .plus-icon {
      visibility: visible;
    }
  }
  ${(props: Props) =>
    props.isShowHover &&
    css`
      &:hover .right {
        background: var(--background-primary);
        border: 0.5px solid var(--border-primary);
        border-radius: var(--border-radius-8);
      }
    `}
  .subscriber {
    cursor: auto;
  }
  ${mobile_xl(css`
    padding: var(--space-0);
  `)}
`;
const RightSubTitle = styled.h6<Props>`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  margin: var(--space-0);
  white-space: nowrap;
  min-width: 70px;
`;

const AssignGroup = styled.div`
  ul {
    ${AlignCenter}
    list-style-type: none;
    padding: var(--space-0);
    margin: var(--space-0);
  }

  li {
    display: flex;
    margin-right: -8px;
    border-radius: var(--border-radius-full);
    background-color: var(--background-muted);
    z-index: var(--z-index-base);
    width: 20px;
    height: 20px;
    ${FlexCenter}
    border: 1px solid var(--background-secondary);
  }

  .plus-icon {
    visibility: hidden;
    z-index: var(--z-index-base);
  }
`;
const AvatarImage = styled.div`
  ${AlignCenter}
  border-radius: var(--border-radius-full);
  > div > img {
    max-width: 24px;
  }
`;
const TimeLog = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-14);
  padding: var(--space-12) var(--space-24);
  ${mobile_xl(css`
    padding: var(--space-0);
  `)}
`;

const TotalTrackedTime = styled.div`
  ${FlexBetween}
  gap: var(--space-10);
  padding: var(--space-12) var(--space-24);
  border-bottom: 0.5px solid var(--border-primary);
  span {
    ${Typography.body_md}
    color: var(--text-primary);
  }
  ${mobile_xl(css`
    padding: var(--space-0) var(--space-0) var(--space-20);
  `)}
`;

const TimerHead = styled.div`
  ${FlexBetween}
  gap: var(--space-10);
`;

const TimeLogTitle = styled.h6`
  ${Typography.body_md_semibold}
  color: var(--text-secondary);
  margin: var(--space-0);
`;

const TimeLogContent = styled.div`
  display: flex;
  gap: var(--space-4);
  ${mobile_xl(css`
    flex-wrap: wrap;
  `)}
`;

const TaskArea = styled.div<{ figmaRefreshLoading?: boolean }>`
  width: 100%;
  ${Typography.body_lg}
  color: var(--text-secondary);
  margin: var(--space-0);
  border: none;
  resize: none;
  margin-top: var(--space-4);
  ${HideScrollbar}
  .e-rte-table td,
  .e-rte-table th {
    border: 0.5px solid var(--border-primary);
  }
  ${mobile_xl(css`
    .ant-image .ant-image-img {
      width: auto;
    }
  `)}
`;

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  ${mobile_xl(css`
    gap: var(--space-14);
  `)}
  a {
    color: var(--text-link);
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }

  .file-box {
    cursor: pointer;
    max-width: max-content;
    display: inline-flex;
    padding: var(--space-10) var(--space-16) var(--space-10) var(--space-8);
    background-color: var(--background-primary);
    border: 0.5px solid var(--border-primary);
    border-radius: var(--border-radius-8);
    box-shadow: var(--shadow-card);
    align-items: center;
    gap: var(--space-8);
    margin-top: var(--space-12);
  }
  .textarea {
    width: 130px;
    white-space: unset;
  }
  .h4 {
    ${Typography.body_md_medium}
    color: var(--text-primary);
    margin: var(--space-0) var(--space-0) var(--space-4);
    ${LineClamp(1)}
    white-space: inherit;
  }
  .p {
    ${Typography.body_xs}
    color: var(--text-secondary);
    margin: var(--space-0);
  }
  .svg {
    width: 32px;
    height: 32px;
  }
`;

const ActivityView = styled.div<Props>`
  display: flex;
  flex-direction: column-reverse;
  margin-bottom: var(--space-24);
  ${mobile_xl(css<Props>`
    margin-bottom: ${({ isKeyboardVisible }) => (isKeyboardVisible ? 'var(--space-12)' : 'var(--space-80)')};
  `)}
`;
const FormBlock = styled.form``;

const InputTitle = styled.div`
  width: 100%;
  display: block;
  ${Typography.heading_lg}
  color: var(--text-primary);
  padding: var(--space-0);
  border: none;
  outline: none;
  white-space: pre-wrap;
  word-break: break-word;
  cursor: text;
  ::placeholder {
    ${Typography.heading_lg}
    color: var(--text-secondary);
  }
  a {
    color: var(--text-secondary);
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
`;

const Form = styled.div`
  display: flex;
  align-items: baseline;
  gap: var(--space-8);
  ${mobile_xl(css`
    gap: var(--space-4);
  `)}
  .img {
    width: 20px;
    height: 20px;
    padding-top: var(--space-2);
    cursor: pointer;
  }
  .task-open-icon {
    path {
      fill: var(--text-secondary);
    }
    path.first-path {
      fill: var(--background-primary);
    }
  }
  .complete-icon {
    .complete-fill {
      fill: var(--text-tertiary);
    }
  }
`;

const ProjectName = styled.div`
  ${Typography.body_lg_medium}
  margin: var(--space-0);
  color: var(--text-secondary);
  padding: var(--space-2) var(--space-4);
  cursor: pointer;
  &:hover {
    color: var(--text-primary);
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-4);
  }
`;

const OverLayDiv = styled.div<Props>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const TaskDetailContainer = styled.div<Props>`
  max-width: 850px;
  width: -webkit-fill-available;
  margin: var(--space-0) auto;
  display: flex;
  flex-direction: column;
  padding-inline: var(--space-24);
  ${mobile_xl(css<Props>`
    padding: var(--space-0);
    gap: var(--space-24);
  `)}
`;

const TaskContainer = styled.div`
  max-width: 850px;
  width: 100%;
  margin: var(--space-0) auto;
  ${FlexBetween}
`;

const Timer = styled.div`
  position: relative;
  .active-timer {
    position: absolute;
    left: -13px;
    z-index: var(--z-index-11);
    border: 0.5px solid var(--border-primary);
    box-shadow: none;
  }
  .time-icon {
    path {
      stroke: var(--text-secondary);
    }
  }
  .pointer-event-auto {
    pointer-events: auto;
  }
  .pointer-event-none {
    pointer-events: none;
  }
`;

const Action = styled.div`
  ${AlignCenter}
  width: max-content;
  border-radius: 0 var(--border-radius-full) var(--border-radius-full) var(--border-radius-0);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  cursor: pointer;
  position: relative;
  z-index: var(--z-index-base);
  span {
    ${Typography.body_md_medium};
    color: var(--text-primary);
  }
`;

const Timelog = styled.p`
  margin: var(--space-0);
  ${Typography.body_sm};
  span {
    ${Typography.body_sm_medium};
    color: var(--text-white);
  }
`;

const ReactionShowWrapper = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
  width: fit-content;
  ${mobile_xl(css`
    padding-top: var(--space-2);
  `)}
`;

const Time = styled.div`
  padding: var(--space-3) var(--space-11) var(--space-2) var(--space-24);
  width: 50px;
  ${(props: { isLargeHours: boolean }) =>
    props.isLargeHours &&
    css`
      width: 52px;
    `}
  ${mobile_xl(css`
    padding-top: var(--space-2);
  `)}
`;
const AddSubTask = styled.div`
  ${AlignCenter}
  gap: var(--space-2);
  cursor: pointer;
  width: fit-content;
  padding: var(--space-5) var(--space-10) var(--space-5) var(--space-8);
  border-radius: var(--border-radius-8);
  cursor: pointer;
  p {
    ${Typography.body_sm_medium}
    color: var(--text-secondary);
    margin: var(--space-0);
  }
  &:hover {
    background-color: var(--neutral-secondary);
    p {
      color: var(--text-primary);
    }
    svg path {
      fill: var(--text-primary);
    }
    background-color: var(--neutral-secondary);
  }
  ${mobile_xl(css`
    p {
      color: var(--text-primary);
    }
    svg path {
      fill: var(--text-primary);
    }
  `)}
`;

const SubTaskList = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  &.has-mainTask {
    gap: var(--space-0);
  }
  ${mobile_xl(css`
    gap: var(--space-24);
  `)}
`;

const IconHidden = styled.div<{ isDragging?: boolean }>`
  position: absolute;
  left: -15px;
  top: 9px;
  cursor: ${({ isDragging }) => (isDragging ? 'grabbing' : 'pointer')} !important;
  svg {
    opacity: 0;
  }
  &:active {
    cursor: grabbing !important;
  }
  &[data-dnd-kit-draggable] {
    cursor: ${({ isDragging }) => (isDragging ? 'grabbing' : 'pointer')} !important;
  }
  ${mobile_xl(css`
    svg {
      display: none;
    }
  `)}
`;

const Subtask = styled.div<Props>`
  padding: var(--space-4) var(--space-12) var(--space-4) var(--space-6);
  display: flex;
  justify-content: space-between;
  gap: var(--space-40);
  cursor: pointer;
  border-radius: var(--border-radius-full);
  border: 0.5px solid transparent !important;
  position: relative;
  &:hover {
    border: 0.5px solid var(--border-primary) !important;
    background-color: var(--background-primary) !important;
    box-shadow: var(--shadow-card) !important;
    ${IconHidden} svg {
      opacity: 1;
    }
    .plus-icon {
      visibility: visible;
      z-index: var(--z-index-base);
      .fill-color {
        stroke: var(--neutral-secondary);
      }
    }
  }
  ${(props: Props) =>
    props.isSelected &&
    css`
      background: var(--background-primary) !important;
      border: 0.5px solid var(--border-primary) !important;
      box-shadow: var(--shadow-card) !important;
    `}
  ${(props: Props) =>
    props.isActive &&
    css`
      border: 0.5px solid var(--border-primary) !important;
      background-color: var(--background-primary) !important;
      box-shadow: var(--shadow-card) !important;
    `}
  ${mobile_xl(css`
    min-height: 24px;
    padding: var(--space-10) var(--space-8) var(--space-10) var(--space-4);
    &:hover {
      border: 0.5px solid transparent !important;
      background-color: unset !important;
      box-shadow: unset !important;
    }
  `)}
`;

const TaskItem = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
  width: 100%;

  ${mobile_xl(css`
    justify-content: space-between;
    width: 100%;
    gap: var(--space-8);
  `)}
`;
const Form1 = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
`;

const TaskTitleDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
`;

const TaskId = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
  text-transform: uppercase;
  white-space: nowrap;
`;

const Label = styled.label`
  ${Typography.body_md}
  color: var(--text-primary);
  margin: var(--space-0);
  ${LineClamp(1)}
  word-break: break-all;
  a {
    color: var(--text-link);
    display: inline-block;
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
`;
const Right = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
  ${mobile_xl(css`
    display: none;
  `)}
`;
const DueDate = styled.div`
  ${FlexCenter}
  gap: var(--space-4);
  cursor: default;
  span {
    ${AlignCenter}
    gap: var(--space-4);
  }
`;

const DetailTask = styled.p<Props>`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
  white-space: nowrap;

  ${(props: Props) =>
    props.isOverdue &&
    css`
      color: var(--accent-error);
    `}
`;

const SubtaskTitle = styled.div<Props>`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);

  ${(props: Props) =>
    props.isMobile &&
    css`
      display: none;
    `}
`;
const MainTask = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
  span {
    color: var(--text-secondary);
    ${Typography.body_lg}
    white-space: nowrap;
  }
`;
const Form2 = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
  border: 0.5px solid transparent;
  padding: var(--space-3) var(--space-10) var(--space-3) var(--space-6);
  border-radius: var(--border-radius-full);
  cursor: pointer;
  &:hover {
    border: 0.5px solid var(--border-primary);
    background-color: var(--background-primary);
  }
  .sub-task-icon {
    padding: var(--space-0);
    &:hover {
      background-color: unset;
      svg {
        filter: unset;
      }
    }
  }
`;
const TaskLabel = styled.div`
  color: var(--text-primary);
  ${Typography.body_lg}
  ${LineClamp(1)}
  word-break: break-all;
`;

const EditIcon = styled.div`
  padding: var(--space-5);
  z-index: var(--z-index-base);
  background-color: var(--neutral-secondary);
  border-radius: var(--border-radius-full);
  height: max-content;
  ${FlexCenter}
`;
const Div = styled.div<Props>`
  display: flex;
  gap: var(--space-12);
  ${(props) =>
    props.isComment &&
    css`
      ${mobile_xl(css`
        align-items: flex-start;
        width: calc(100% - 34px);
      `)}
    `}
`;
const Div2 = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  img {
    margin-top: var(--space-0);
  }
`;
const BorderDiv = styled.div`
  position: absolute;
  border-left: 0.5px solid var(--border-primary);
  height: 100%;
  left: 24px;
  top: 10px;
  z-index: var(--z-index-0);
`;
const DivSubTask = styled.div`
  border-bottom: 0.5px solid var(--border-primary);
  padding-block: var(--space-4);
  display: flex;
  flex-direction: column;
`;

const StatusIcon = styled.div`
  max-width: 24px;
  width: 100%;
  height: 24px;
  z-index: var(--z-index-base);
  background-color: var(--neutral-secondary);
  border-radius: var(--border-radius-full);
  ${FlexCenter}
  svg {
    width: 14px;
    height: 14px;
  }
  .complete-icon {
    path.complete-fill {
      fill: var(--text-tertiary);
    }
  }
`;

const SvgFile = styled.div`
  width: 32px;
  height: 32px;
`;

const MultipleLabel = styled.div`
  border-radius: var(--border-radius-full);
  border: 0.5px solid var(--border-primary);
  display: flex;
  cursor: auto;
  ${mobile_xl(css`
    display: none;
  `)}
`;

const DropBlock = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
  padding: var(--space-2) var(--space-10) var(--space-2) var(--space-6);
  border-left: 0.5px solid var(--border-primary);
  &.left-border {
    border-left: none;
  }
`;

const DotIcon = styled.div<Props>`
  margin: var(--space-4);
  width: 8px;
  height: 8px;
  border-radius: var(--border-radius-full);

  ${(props: Props) =>
    props.color &&
    css`
      background-color: ${props.color};
    `}
`;
const DropLabel = styled.div`
  ${Typography.body_md}
  color: var(--text-primary);
  white-space: nowrap;
`;

export const globalDragCursor = css`
  body {
    &[data-dnd-kit-portal] {
      cursor: grabbing !important;
    }
  }

  [data-dnd-kit-drag-handle] {
    cursor: grab !important;

    &:active,
    &[data-dnd-kit-draggable] {
      cursor: grabbing !important;
    }
  }

  [data-dnd-kit-draggable] {
    cursor: grabbing !important;
  }
`;

const SubTaskSection = styled.div``;

const AddSubTaskSection = styled.div`
  border-bottom: 0.5px solid var(--border-primary);
  padding-bottom: var(--space-6);
  display: flex;
  justify-content: space-between;
`;

const SubtaskHeadLeft = styled.div`
  ${AlignCenter}
  gap: var(--space-12);

  p {
    ${Typography.body_md_medium}
    margin: var(--space-0);
    color: var(--text-secondary);
  }
`;
const SubtaskHeadRight = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
`;

const TaskIndicatorText = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
`;

const TaskIndicator = styled.div<Props>`
  ${AlignCenter}
  gap: var(--space-6);
  .circle {
    width: 16px;
    height: 16px;
    border-radius: var(--border-radius-full);
    position: relative;
    background: conic-gradient(
      var(--brand-primary) ${(props) => props.completePercentage! * 3.6}deg,
      var(--text-placeholder) 0deg ${(props) => props.completePercentage! * 3.6}deg
    );
  }
  .innerCircle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    background: var(--background-secondary);
    border-radius: var(--border-radius-full);
  }
`;

const GithubMainDiv = styled.div`
  padding: var(--space-6) var(--space-12);
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-primary);
  border-radius: var(--border-radius-6);
  ${AlignCenter}
  gap: var(--space-8);
  cursor: pointer;
  ${mobile_xl(css`
    align-items: baseline;
  `)}
`;
const GithubSmallIcon = styled.div`
  display: flex;
  .github-icon {
    path {
      fill: var(--text-primary);
    }
  }
`;
const BottomContent = styled.div`
  ${AlignCenter}
  flex-wrap: wrap;
  gap: var(--space-4);
  ${mobile_xl(css`
    max-width: 315px;
  `)}
`;
const Texts = styled.div`
  ${Typography.body_md_medium};
  color: var(--text-secondary);
`;
const Dot = styled.div`
  width: 3px;
  height: 3px;
  background-color: var(--text-secondary);
  border-radius: var(--border-radius-full);
  margin: var(--space-5);
  ${mobile_xl(css`
    display: none;
  `)}
`;

const GithubTitle = styled.div`
  ${Typography.body_md_medium};
  color: var(--text-primary);
  ${LineClamp(1)}
  ${mobile_xl(css`
    ${Typography.body_sm_medium};
  `)}
`;
const MergedLabel = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
  p {
    ${Typography.body_md_medium}
    color: var(--text-secondary);
    margin: var(--space-0);
  }
`;
const LabelIcon = styled.div`
  width: 14px;
  height: 14px;
  display: flex;
  flex-direction: column;
`;
const MergeText = styled.div`
  ${Typography.body_md};
  color: var(--text-secondary);
`;

const TaskAreaFile = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-8);
  cursor: pointer;
  margin-top: var(--space-12);
  ${mobile_xl(css`
    margin-top: var(--space-14);
    gap: var(--space-10);
  `)}
`;

const ProgressBar = styled.div<Props>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: var(--neutral-secondary);
  z-index: var(--z-index-0);
  width: ${(props) => props.progress}%;
  ${(props) =>
    props.isTimeOver &&
    css`
      background: var(--overlay-time-over);
    `}
`;
const ProgressWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  border-radius: var(--border-radius-0) 36px 36px var(--border-radius-0);
  z-index: var(--z-index-negative);
`;
const Icons = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
  ${mobile_xl(css`
    gap: var(--space-18);
  `)}
`;
const FileIconDiv = styled.div`
  position: relative;
  .file-text {
    display: flex;
    justify-content: center;
    position: absolute;
    width: 50%;
    font-weight: 700;
    color: var(--text-secondary);
  }
`;

const FileType = styled.div<Props>`
  display: flex;
  justify-content: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-46%, -30%);
  color: var(--text-primary);
  ${({ fontSize }) => fontSize && `font-size: ${fontSize}px;`}
`;

const GithubPRSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  margin-top: var(--space-20);
  ${mobile_xl(css`
    margin-top: var(--space-12);
    gap: var(--space-8);
  `)}
`;
const ButtonIcon = styled.div`
  padding: var(--space-4);
  border-radius: var(--border-radius-12);
  display: flex;
  &:hover {
    background-color: var(--neutral-secondary);
    input {
      filter: brightness(var(--brightness-value));
    }
  }
`;
const LinkSection = styled.div`
  border-bottom: 0.5px solid var(--border-primary);
  padding-bottom: var(--space-12);
`;
const LinkCard = styled.div`
  padding: var(--space-8) var(--space-10);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  display: flex;
  border-radius: var(--border-radius-8);
  gap: var(--space-8);
  margin-bottom: var(--space-8);
  ${mobile_xl(css`
    gap: var(--space-4);
  `)}
  align-items: center;
`;
const Content = styled.div`
  width: 100%;
  display: flex;
  gap: var(--space-8);
`;
const SocialIcon = styled.div`
  width: 20px;
  height: 20px;
  img {
    border-radius: var(--border-radius-4);
  }
`;

const ContentRightSection = styled.div`
  width: 100%;
  display: flex;
  gap: var(--space-12);
  justify-content: space-between;
  ${mobile_xl(css`
    flex-direction: column;
    gap: var(--space-2);
  `)}
`;

const LinkText = styled.p`
  width: 100%;
  margin: var(--space-0);
  ${Typography.body_md_medium}
  color: var(--text-primary);
  ${LineClamp(1)}
  word-break: break-all;
`;

const LinkRightContent = styled.div`
  width: 100%;
  display: flex;
  max-width: max-content;
  justify-content: end;
  gap: var(--space-6);
`;
const TimeText = styled.p`
  width: max-content;
  white-space: nowrap;
  text-align: end;
  margin: var(--space-0);
  ${Typography.body_md};
  color: var(--text-secondary);
  ${mobile_xl(css`
    max-width: max-content;
    text-align: start;
  `)}
`;

const LinkTitle = styled.div`
  ${FlexBetween}
  margin-block: var(--space-20) var(--space-7);
  p {
    ${Typography.body_md_medium};
    color: var(--text-secondary);
    margin: var(--space-0);
  }
  ${mobile_xl(css`
    margin-top: var(--space-24);
  `)}
`;

const TooltipContent = styled.div`
  border-radius: var(--border-radius-4);
  ${AlignCenter}
  gap: var(--space-2);
`;

const LabelContainer = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
`;

const DropDiv = styled.div`
  .active-state {
    background: var(--neutral-secondary);
    border-radius: var(--border-radius-4);
  }
`;

const SubTaskDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
`;
const IconDiv = styled.div<{ isLoading?: boolean }>`
  display: flex;
  padding: var(--space-5);
  border-radius: var(--border-radius-8);
  cursor: ${(props) => (props.isLoading ? 'default' : 'pointer')};
  svg {
    fill: var(--text-secondary);
  }
  ${(props) =>
    !props.isLoading &&
    css`
      &:hover {
        background-color: var(--neutral-secondary);
        svg {
          fill: var(--text-primary);
        }
      }
    `}
`;

const AttachmentContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const HiddenFileInput = styled.input`
  display: none;
`;

export {
  Group,
  LeftBar,
  Header,
  HeaderBlock,
  HeaderTitle,
  HeaderContent,
  Text,
  Activity,
  ActivityTitle,
  ItemBlock,
  ItemChange,
  SubTitle,
  ActivityContentView,
  ActivitySubContent,
  LeftBarView,
  RightBar,
  Listening,
  RightItemBlock,
  RightSubTitle,
  AssignGroup,
  TimeLog,
  TimerHead,
  TimeLogTitle,
  TimeLogContent,
  TaskArea,
  TextBlock,
  ActivityView,
  FormBlock,
  InputTitle,
  AvatarImage,
  RightItemBlocks,
  Form,
  ProjectName,
  OverLayDiv,
  TaskDetailContainer,
  TaskContainer,
  RightSection,
  ReactionDiv,
  Portion,
  ReactionShow,
  FileSection,
  Action,
  Timer,
  ReactionShowWrapper,
  Time,
  AddSubTask,
  Subtask,
  TaskItem,
  Form1,
  Label,
  Right,
  DueDate,
  DetailTask,
  SubtaskTitle,
  MainTask,
  Form2,
  TaskLabel,
  EditIcon,
  Div,
  Div2,
  BorderDiv,
  DivSubTask,
  StatusIcon,
  SvgFile,
  SubTaskList,
  MultipleLabel,
  DropLabel,
  DropBlock,
  DotIcon,
  SubTaskSection,
  AddSubTaskSection,
  SubtaskHeadLeft,
  SubtaskHeadRight,
  TaskIndicatorText,
  TaskIndicator,
  SubText,
  IconHidden,
  GithubMainDiv,
  GithubSmallIcon,
  BottomContent,
  Texts,
  Dot,
  GithubTitle,
  LabelIcon,
  MergedLabel,
  MergeText,
  TaskAreaFile,
  ProgressBar,
  ProgressWrapper,
  Icons,
  FileIconDiv,
  FileType,
  GithubPRSection,
  ButtonIcon,
  LinkSection,
  LinkCard,
  Content,
  SocialIcon,
  LinkText,
  LinkRightContent,
  TimeText,
  LinkTitle,
  TooltipContent,
  Timelog,
  TotalTrackedTime,
  ReactionContainer,
  LabelContainer,
  ContentRightSection,
  DropDiv,
  SubTaskDiv,
  IconDiv,
  TaskId,
  TaskTitleDiv,
  AttachmentContainer,
  HiddenFileInput,
  ActivitySubContentLeft,
  CompanySection,
  CompanyName
};
